// extracted by mini-css-extract-plugin
module.exports = {"deck":"Deck_deck_pP4lD","deck__info":"Deck_deck__info_L6WSv","deck__icon":"Deck_deck__icon_38tfm","deck__tag":"Deck_deck__tag_T0LGP"};